import {IStoreState, IUserReducerState} from "../types";
import {eq} from "lodash";

export const isLoggedIn = ({user}: IStoreState) => user.is_logged_in;
export const isDataRequested = ({user}: IStoreState) => user.is_data_requested;
export const isAdditionalInformationRequired = ({user}: IStoreState) =>
	user.additional_information_required;
export const isConditionsAreAccepted = ({user}: IStoreState) => user;
export const isNeedToRegisterForYear = ({user}: IStoreState): boolean =>
	(eq(user.recovered, 0) && !user.additional_information_required) ||
	!!user.should_be_recovered;
export const getUserId = (state: IStoreState): number => state.user.id;
export const getUser = ({user}: IStoreState): IUserReducerState => user;
export const getSSOUser = ({user}: IStoreState) => user.gigyaSSOUserData;
export const getOIDCPayload = ({user}: IStoreState) => user.oidc_payload;
